import { Role } from '@enums/role.enum';
import { PermissionAttribute, PermissionAttributeJson } from '@models/permission-attribute';

export interface PermissionJson {
  id: number;
  company_role: Role;
  permission_attributes: Partial<PermissionAttributeJson>[];
}

export class Permission {
  constructor(
    public id?: number,
    public role?: Role,
    public permissionAttributes?: PermissionAttribute[]
  ) {}

  static fromJson(json: Partial<PermissionJson>): Permission {
    return new Permission(
      json.id,
      json.company_role,
      json.permission_attributes
        ? json.permission_attributes.map(permissionAttributeJson =>
            PermissionAttribute.fromJson(permissionAttributeJson)
          )
        : []
    );
  }
}
